<template>
    <div class="container">
        <div class="header">
            <img :src="icon" class="icon-app">
            <div class="headings">
                <div class="titles">
                    <h5>{{ software.name }}</h5><h6>{{ software.role }}</h6>
                </div>
                <div class="headline">{{ software.owner }}</div>
                
            </div>
            <a target="_blank" :href="software.url">
            <img src="@/assets/icons/link.svg" class="icon-link" v-if="isLink"/>
        </a>
        </div> 

        <p class="caption">{{ software.description }}</p>
        <ul>
            <li v-for="item in software.awards" :key="item.hash">
                <a target="_blank" :href="item.url" class="award">
                    <img src="@/assets/icons/trophy.svg" class="icon-trophy">
                    <span class="summary">{{ item.name }}</span>
                </a>
            </li>
        </ul>        
    </div>
</template>

<script lang="ts">
import { ResumeExperiencePositionSoftware } from '@/models/Resume'
import { computed, defineComponent, PropType } from 'vue'

function getImgUrl(image: string) {
    const images = require.context('@/../resume/apps/', false)
    return images('./' + image)
 }

export default defineComponent({
    name: "experience-position-software",
    props: {
        software: {
            type: Object as PropType<ResumeExperiencePositionSoftware>,
            required: true
        } 
    },
    computed: {
        icon(): string {
            return getImgUrl(this.software!.icon)
        },
        isLink(): boolean {
            return this.software!.url != null
        }
    }
})
</script>

<style lang="stylus" scoped>

@import "~../../src/styles/styles";

h5, h6 {
    display inline
}

@media print {
    .container {
        page-break-before: auto;
        page-break-after: auto; 
        page-break-inside: avoid;
        position: relative;
    }
}


.titles {
    display: flex
    gap: 4pt    
}

.header {
    display: flex
    gap: 4pt
    flex-direction row    
}

.headings {
    display: flex
    gap: 2pt
    flex-direction column
    flex-grow: 1
}

.content {
    display: flex
    gap: 4pt
    flex-direction column
    margin-left: 8pt
}

.information {
    display: flex
    gap: 2pt
    flex-direction column
}

.container {
    display: flex
    // gap: 8pt
    box-shadow: inset 0 0 0 1000px background; // https://stackoverflow.com/a/15185205/4698501
    padding: 8pt;
    border-radius: 10pt;
    align-items: stretch
    flex-direction column
    gap: 4pt
    // background-color: grey;
    // -webkit-print-color-adjust: exact;
}

.icon-app {
    width: 24pt
    height: @width
    border-radius: (@height/4)pt;
}

.icon-link {
    width: 14pt
    height: @width       
}

.icon-trophy {
    width: 10pt
    height: @width  
    // fill: purple     
}

.award {
    display: flex
    align-items flex-start;   
    gap: 2pt 
    text-decoration: none;


    :hover {
        text-decoration: underline;
    }
}



.link {

}
    
</style>